// extracted by mini-css-extract-plugin
export var cardgroup = "card-group-expanded-module--cardgroup--SXuLk";